import { InputError, LightTooltip, notify, ShowInfo } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeStep, nextStep, prevStep } from '../redux/actions/StepperAction';
import { useEffect, useState } from 'react';
import { applyDiscountCode, cancelTransaction, getStatus, payment } from '../../api/MoadianService';
import { setStatus } from '../redux/actions/TokneAction';
import { Toaster } from 'react-hot-toast';
import { FormProvider, useForm } from "react-hook-form";
import { Button, Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../api/ApiClient";

export default function Payment() {
    const dispatch = useDispatch();
    const tokenInfo = useSelector(state => state.Token)
    const [price, setPrice] = useState(0);
    const [isDiscount, setIsDiscount] = useState(false);
    const [paymentLink, setPaymentLink] = useState('');
    const [isReturnDialogOpen, setIsReturnDialogOpen] = useState(false);

    const navigate = useNavigate();
    const certType = useSelector(state => state.FirstInfo.certType);

    const handleConfirmReturn = () => {
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;
        navigate('/');
    }

    const handleBackward = () => {
        if (certType === 'COMPANY') {
            navigate('/company/list')
        } else {
            setIsReturnDialogOpen(true);
        }
    }

    return (
        <div>
            <Dialog open={isReturnDialogOpen} onClose={() => setIsReturnDialogOpen(false)}>
                <DialogContent>
                    <Grid2 justifyContent="center" spacing={1}>
                        <Grid2 xs={12} textAlign="center" alignItems="center" justifyContent="center">
                            <p className="show-info-title my-3 text-center me-1 my-0 me-lg-2 p-0">عودت وجه</p>
                            <p className="show-info-text text-center me-1 me-lg-2 my-0 p-0">
                                درخواست عودت وجه شما با موفقیت ثبت شد
                            </p>
                            <p className="show-info-text text-center me-1 me-lg-2 my-0 p-0">
                                وجه گواهی شما طی ۱۰ روز کاری به حساب شما عودت داده خواهد شد
                            </p>
                        </Grid2>
                        <Grid2 xs={12} textAlign="center">
                            <div className='text-center d-flex mt-3 justify-content-center'>
                                <button
                                    className='btn border text-form-title ms-2 w-50'
                                    style={{ padding: "1.5% 13%" }}
                                    onClick={handleConfirmReturn}
                                >
                                    بستن
                                </button>
                            </div>
                        </Grid2>
                    </Grid2>
                </DialogContent>
            </Dialog>

            {
                tokenInfo.status == 'INITIAL'
                    ? (<UnPay
                        dispatch={dispatch}
                        tokenInfo={tokenInfo}
                        setPrice={setPrice}
                        price={price}
                        setIsDiscount={setIsDiscount}
                        handleBackward={handleBackward}
                    />)
                    : (<Pay
                        dispatch={dispatch}
                        price={price}
                        isDiscount={isDiscount}
                        handleBackward={handleBackward} />)
            }
        </div>
    )
}

function UnPay({ dispatch, tokenInfo, setPrice, price, setIsDiscount, handleBackward }) {

    const [paymentLink, setPaymentLink] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingDiscount, setIsLoadingDiscount] = useState(false);
    const [pollingInterval, setPollingInterval] = useState(null);
    const [isDiscountCodeModalOpen, setIsDiscountCodeModalOpen] = useState(false);
    const [discountCode, setDiscountCode] = useState("");
    const [showDiscountError, setShowDiscountError] = useState(false)

    useEffect(() => {
        payment(tokenInfo.transactionId).then(response => {

            if (response?.data?.errorCode == 'OK') {
                setPrice(response?.data?.price)
                setPaymentLink(response?.data?.link)
            }
        })
            .catch(error => notify(error?.response?.data?.message))
    }, [])

    const fetchData = async () => {

        getStatus(tokenInfo.transactionId).then(response => {

            if (response?.data?.transactionStatus == 'PAID') {

                clearInterval(pollingInterval);
                let formData = { status: response?.data?.transactionStatus }
                dispatch(setStatus(formData))

            }

        }).catch(error => notify(error?.response?.data?.message))

    };

    const goToPaymentPage = async (e) => {
        e.preventDefault();
        // Set isSubmitting to true to indicate that the form is being submitted
        setIsSubmitting(true);
        const externalLink = paymentLink;
        window.open(externalLink, '_blank');
        // window.location.href = externalLink;
        try {
            // Call fetchData to initiate the first API call
            await fetchData();

            // Set up polling interval (every 5 seconds in this example)
            const pollingInterval = setInterval(() => {
                fetchData();
            }, 5000);

            return () => clearInterval(pollingInterval);
        } finally {
            setIsSubmitting(false);
        }
    };

    const applyCode = () => {

        if (discountCode) {
            setIsLoadingDiscount(true)

            applyDiscountCode(tokenInfo.transactionId, discountCode).then((response) => {
                setIsDiscountCodeModalOpen(false);
                setPrice(response?.data?.price)
                setPaymentLink(response?.data?.link)
                setIsLoadingDiscount(false)

                if (response?.data?.price == 0) {
                    fetchData();
                    setIsDiscount(true)
                }

            }).catch((error) => {
                setIsLoadingDiscount(false)
                notify(error?.response?.data?.message)
            })
        } else {
            setShowDiscountError(true)
        }

    }

    return (
        <>
            <ShowInfo
                title={'پرداخت'}
                message={'پرداخت با استفاده از درگاه اینترنتی'}
                discountCode={true}
                setIsDiscountCodeModalOpen={setIsDiscountCodeModalOpen}
            />

            <div>
                <Dialog open={isDiscountCodeModalOpen} onClose={() => setIsDiscountCodeModalOpen(false)}>
                    <DialogContent>
                        <Grid2 justifyContent="center" spacing={1}>
                            <Grid2 xs={12} lg={7}>
                                <p className=" show-info-title me-1 my-0 me-lg-2 p-0 ">کد تخفیف</p>
                                <p className="show-info-text me-1 me-lg-2 my-0 p-0 ">کد تخفیف ارسال شده را وارد کنید.</p>

                            </Grid2>
                            <Grid2 md={7} xs={12} >
                                <TextField
                                    value={discountCode}
                                    onChange={(event) => { setDiscountCode(event.target.value); setShowDiscountError(false) }}
                                    sx={{ pt: 2 }} fullWidth size="small" placeholder="کد تخفیف خود را وارد کنید" />
                                {showDiscountError && <InputError message={'کد تخفیف خود را وارد کنید'} show={showDiscountError} />}
                            </Grid2>
                            <Grid2 md={7} xs={12} textAlign="center">
                                <div className='text-center d-flex mt-3'>
                                    <button
                                        className='btn border text-form-title ms-2 w-100'
                                        style={{ "padding": "1.5% 13%" }}
                                        onClick={() => setIsDiscountCodeModalOpen(false)}
                                    >بستن
                                    </button>

                                    <button
                                        className='btn text-form-button me-2 w-100'
                                        style={{ "background": "#044448", "padding": "1.5% 13%" }}
                                        onClick={applyCode}
                                        disabled={isLoadingDiscount}
                                    >ادامه
                                    </button>
                                </div>

                            </Grid2>
                        </Grid2>
                    </DialogContent>

                </Dialog>
                <Toaster />

                <div className='row justify-content-center m-0 w-100 my-3 mt-5'>
                    <div className='col-10 col-md-6 border rounded text-format shadow-sm p-1 p-md-2'>

                        <div className='row'>

                            <div className='col-9 col-md-8 ps-0'>
                                <span
                                    className='text-payment m-0'
                                >مجموع قیمت قابل پرداخت (با احتساب ۹ درصد مالیات):
                                </span>
                            </div>

                            <div className='col-1 d-none d-md-block p-0'><LightTooltip tooltip_title={'کد ارسال شده'} />
                            </div>

                            <div className='col-1 p-0 me-2'>
                                <span className="badge rounded-pill bg-light-danger pt-md-1 text-payment-badge"
                                >پرداخت نشده</span>
                            </div>

                        </div>

                        <div className='row d-flex justify-content-center my-4 test-dark-success'>
                            <div className='col-8 text-start'><h1>{price.toLocaleString('fa-IR')}  </h1></div>
                            <div className='col-4 p-0 pt-2'><h4>ریال</h4></div>
                        </div>

                    </div>
                </div>

                <div className='row justify-content-center m-0 w-100 my-3 p-0'>
                    <div className='col-10 col-md-6 p-0'>
                        <button
                            onClick={goToPaymentPage}
                            className='btn w-100 text-form-button'
                            style={{ "background": "#044448" }}
                            disabled={isSubmitting}
                        >پرداخت
                        </button>

                    </div>

                </div>

                <div className='row justify-content-center  m-0 w-100 my-3 mt-5'>

                    <div className='col-10 col-md-5 text-center'>
                        <button
                            className='btn border text-form-title ms-2'
                            style={{ "padding": "2.7% 13%" }}
                            onClick={handleBackward}
                        >بازگشت
                        </button>

                        <button
                            disabled
                            className='btn text-form-button me-2'
                            style={{ "background": "#7f7d7ddb", "padding": "1.5% 13%" }}
                        >ادامه
                        </button>
                    </div>
                </div>

                {
                    isSubmitting && (
                        <div className="loading-overlay">
                            <div className="loading-content">
                                <div className="spinner"></div>
                                <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                            </div>
                        </div>
                    )
                }

            </div>
        </>


    )
}

function Pay({ dispatch, price, isDiscount, handleBackward }) {

    const [accountNumber, setAccountNumber] = useState('')
    const [accountNumberError, setAccountNumberError] = useState(false)
    const [shebaNumber, setShebaNumber] = useState('')
    const [shebaNumberError, setShebaNumberError] = useState(false)
    const [cancelReason, setCancelReason] = useState('');
    const [openModal, setOpenModal] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const tokenInfo = useSelector(state => state.Token)
    const navigate = useNavigate();

    const handleCancel = () => {
        setIsModalLoading(true)

        if (shebaNumber.length != 24) {
            setShebaNumberError(true)
            setIsModalLoading(false)
        }

        if (accountNumber.length != 16) {
            setAccountNumberError(true)
            setIsModalLoading(false)
        }
        if (shebaNumber.length == 24 &&
            accountNumber.length == 16) {
            const accountData = {
                accountNumber: accountNumber,
                shebaNumber: shebaNumber,
                cancelReason: cancelReason,
            }

            cancelTransaction(tokenInfo.transactionId, accountData).then(response => {

                setIsModalLoading(false)
                setOpenModal(false)
                handleBackward()

            }).catch(error => {
                notify(error.response.data.message)
                setIsModalLoading(false)
            })
        }


    }

    return (
        <>
            <Dialog open={openModal}>
                <DialogContent>
                    <Grid2 justifyContent="center" spacing={1}>
                        <Grid2 xs={12} lg={7}>
                            <p className=" show-info-title me-1 my-0 me-lg-2 p-0 ">انصراف</p>
                            <p className="show-info-text me-1 me-lg-2 my-0 p-0 ">در صورت انصراف از صدور گواهی ، مبلغی از
                                پول پرداخت شده کسر میشود</p>

                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-2"
                            > شماره کارت <span style={{ color: 'red' , fontSize: '0.7rem' }}>(شماره کارت میبایست با شماره کارتی که با آن پرداخت انجام گردیده یکسان باشد)</span></label>
                            <TextField
                                value={accountNumber}
                                onChange={(event) => { setAccountNumber(event.target.value); setAccountNumberError(false) }}
                                fullWidth size="small" placeholder="شماره کارت خود را وارد کنید" />
                            {accountNumberError && <InputError message={'شماره کارت وارد شده صحیح نیست'} show={accountNumberError} />}
                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-3"
                            >شماره شبا(بدون IR)</label>
                            <TextField
                                value={shebaNumber}
                                onChange={(event) => { setShebaNumber(event.target.value); setShebaNumberError(false) }}
                                fullWidth size="small" placeholder="شماره شبا خود را وارد کنید" />
                            {shebaNumberError && <InputError message={'شماره شبا وارد شده صحیح نیست'} show={shebaNumberError} />}
                        </Grid2>
                        <Grid2 md={7} xs={12} >
                            <label className="form-label text-form-title mt-3"
                            >دلیل انصراف</label>
                            <TextField
                                value={cancelReason}
                                onChange={(event) => { setCancelReason(event.target.value); }}
                                fullWidth size="small" placeholder="لطفا دلیل انصراف خود را بنویسید" />
                        </Grid2>
                        <Grid2 md={7} xs={12} textAlign="center">
                            <div className='text-center d-flex mt-3'>
                                <button
                                    className='btn border text-form-title ms-2 w-100'
                                    style={{ "padding": "1.5% 13%" }}
                                    onClick={() => setOpenModal(false)}
                                >بستن
                                </button>

                                <button
                                    className='btn text-form-button me-2 w-100'
                                    style={{ "background": "#044448", "padding": "1.5% 13%" }}
                                    onClick={handleCancel}
                                    disabled={isModalLoading}
                                >ادامه
                                </button>
                            </div>

                        </Grid2>
                    </Grid2>
                </DialogContent>

            </Dialog>
            <ShowInfo
                title={'پرداخت'}
                message={'پرداخت با استفاده از درگاه اینترنتی'}
            />
            <div>

                <div className='row justify-content-center m-0 w-100 my-3 mt-5'>
                    <div className='col-10 col-md-6 border rounded text-format shadow-sm p-1 p-md-2'>

                        <div className='row'>

                            <div className='col-9 col-md-8 ps-0'>
                                <span
                                    className='text-payment m-0'
                                >مجموع قیمت قابل پرداخت (با احتساب ۹ درصد مالیات):
                                </span>
                            </div>

                            <div className='col-1 d-none d-md-block p-0'><LightTooltip tooltip_title={'کد ارسال شده'} />
                            </div>

                            <div className='col-1 p-0 me-2'>
                                <span className="badge rounded-pill bg-light-success pt-md-1 text-payment-badge"
                                >پرداخت شده</span>
                            </div>

                        </div>

                        <div className='d-flex justify-content-center my-4 test-dark-success'>
                            {
                                isDiscount ? <h4 style={{ "padding": "3% 1% 0% 0%" }}>کد تخفیف 100 درصدی</h4>
                                    :
                                    <>
                                        <h1>{price.toLocaleString('fa-IR')} </h1>
                                        <h4 style={{ "padding": "3% 1% 0% 0%" }}>ریال</h4>
                                    </>

                            }

                        </div>

                    </div>
                </div>

                <div className='row justify-content-center m-0 w-100 my-3 p-0'>
                    <div className='col-10 col-md-6 p-0'>
                        <button className='btn w-100 factor_btn' style={{ cursor: "default" }}>پرداخت انجام شد
                        </button>
                    </div>
                </div>

                <div className='row justify-content-center m-0 w-100 my-3 mt-5'>

                    <div className='col-10 col-md-5 text-center'>
                        <button
                            className='btn border text-form-title ms-2'
                            style={{ "padding": "2.7% 13%" }}
                            onClick={handleBackward}
                        >بازگشت
                        </button>

                        <button
                            onClick={() => dispatch(nextStep())}
                            className='btn text-form-button me-2'
                            style={{ "background": "#044448", "padding": "1.5% 13%" }}
                        >ادامه
                        </button>
                    </div>
                </div>

                <div className='row justify-content-center my-3'>

                    <div className='col-12 col-md-5 text-center cancel-text pointer'
                        onClick={() => setOpenModal(true)}
                    >
                        انصراف از دریافت گواهی
                    </div>
                </div>

            </div>
        </>

    )
}
